import tw from "twin.macro";
import styled from "styled-components";

export const ButtonsCustom = styled.button`${tw`px-8 py-3 font-bold rounded focus:outline-none transition duration-300 border-2 border-black`}
color: #000 !important;
& * {
  color: #000 !important;
}`;
